export const API_URL =
  process.env.REACT_APP_API_DB_HOST || "http://elulaapi.platinumtechnology.vn";
